import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { toast } from "sonner";

export default function Login() {
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      const next = new URLSearchParams(window.location.search).get("next");
      navigate(next || (res.user.role === "admin" ? "/admin" : "/"));
    } else toast.error(res.error);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20">
      <div className="bg-[#12141a] border border-zinc-800 rounded-2xl p-8">
        <h1 className="font-display text-3xl font-extrabold text-white">Sign in</h1>
        <p className="text-zinc-400 text-sm mt-1">Access your orders, artwork vault & re-orders.</p>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div>
            <Label className="text-zinc-300">Email</Label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13]" placeholder="you@email.com" />
          </div>
          <div>
            <div className="flex items-center justify-between"><Label className="text-zinc-300">Password</Label><Link to="/forgot-password" className="text-xs text-[#22c3d6] hover:underline" data-testid="forgot-link">Forgot password?</Link></div>
            <PasswordInput testid="login-password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13]" placeholder="••••••••" />
          </div>
          <Button data-testid="login-submit" disabled={loading} type="submit" className="w-full bg-[#ff6a13] hover:bg-[#ff8a3d] text-white rounded-full h-11 font-semibold">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
        <div className="flex items-center gap-3 my-5">
          <div className="flex-1 h-px bg-zinc-800" /><span className="text-xs text-zinc-600 font-mono-p">OR</span><div className="flex-1 h-px bg-zinc-800" />
        </div>
        <Button data-testid="google-login-btn" onClick={loginWithGoogle} variant="outline" className="w-full rounded-full h-11 border-zinc-700 bg-white text-black hover:bg-zinc-200 font-semibold">
          Continue with Google
        </Button>
        <p className="text-sm text-zinc-500 mt-6 text-center">No account? <Link to="/register" className="text-[#ff6a13] hover:underline" data-testid="go-register">Create one</Link></p>
      </div>
    </div>
  );
}
